import React, { Component } from 'react';
import './Contact.css';

class Contact extends Component {
    render() {
        return (
            <div className="contact-container">
                <div className="contact-text">
                    Vous pouvez me contacter en m'envoyant un mail à cette adresse :
                    <span className="contact-mail">unzestedegourmandises@gmail.com</span>
                </div>
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js